import { useCommonWidgetHandlers } from './use-common-widget-handlers';
import widgetCRUDActions from '@mm/state/actions/WidgetCRUDActions';
import { useDispatch } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import { Dispatch } from 'redux';
import WidgetModel from '@mm/state/model/WidgetModel';
import TypingWidget from '../../../editor/features/build/requestModels/widgets/TypingWidget';

export const useTypingWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();
  const dispatch: Dispatch<StoreState> = useDispatch();

  const addNew = async (dialogueId: number, sortOrder: number) => {
    const newWidget = TypingWidget.make(dialogueId, sortOrder);

    return commonWidgetHandlers.create(newWidget, dialogueId, sortOrder);
  };

  const updateDelay = (widget: WidgetModel, delayValue: number | undefined) => {
    return dispatch(
      widgetCRUDActions.update({
        ...widget,
        config: {
          ...widget.config,
          seconds: delayValue,
        },
      }),
    );
  };

  return {
    updateDelay,
    delete: commonWidgetHandlers.delete,
    addNew,
  };
};
